import { authV3Api, portalApi, portalApiNoInterceptor } from './http';

export const logout = (refreshToken) => portalApi().post('/logout', { refresh_token: refreshToken });

export const directLogin = (payload) => authV3Api().post('/direct-login', payload);

export const verifyTwoFactorLogin = ({
  document,
  orgId,
  password,
  twoFactorCode,
  challengeToken,
  remember2faDays,
}) => {
  const body = {
    document,
    org_id: orgId,
    password,
    two_factor_code: twoFactorCode,
  };

  if (remember2faDays !== undefined && remember2faDays !== null) {
    body.remember_2fa_days = remember2faDays;
  }

  const config = {};
  if (challengeToken) {
    config.headers = { Authorization: `Bearer ${challengeToken}` };
  }
  return portalApiNoInterceptor().post('/auth/two-factor', body, config);
};

export const changePasswordWithUpdateToken = ({ passwordUpdateToken, oldPassword, password, skip = false }) => {
  const body = {
    old_password: oldPassword,
    password,
    skip,
  };

  return portalApiNoInterceptor().post('/change-password', body, {
    headers: {
      Authorization: `Bearer ${passwordUpdateToken}`,
    },
  });
};

export const acceptTerms = () => portalApi().patch('/accept-terms');

export const fetchProfiles = () => portalApi().get('/me/organization');
export const fetchOrganizationProfile = () => portalApi().get('/me/member');

export const fetchRoles = () => portalApi().get('/role');

export const fetchProfessions = () => portalApi().get('/professions');

export const fetchOrganization = (organizationId) => portalApi().get(`/organization/${organizationId}`);

export const resetAllPasswords = (payload) => portalApi().post('/user/reset-password', payload);
export const resetCorporatePassword = (payload) => portalApi().post('/member/reset-password', payload);
export const changePassword = (payload) => portalApi().post('/change-password', payload);

export const fetchMembersByOrganization = (organizationId, searchParams) =>
  portalApi().get(`/${organizationId}/member?${searchParams}`);
export const fetchUnitsByOrganization = (organizationId) => portalApi().get(`/${organizationId}/unit?page_size=9999`);
export const fetchMemberByOrganization = (organizationId, memberId) =>
  portalApi().get(`/${organizationId}/member/${memberId}`);
export const updateMemberByOrganization = (organizationId, memberId, payload) =>
  portalApi().patch(`/${organizationId}/member/${memberId}`, payload);
export const updateMemberPasswordByOrganization = (organizationId, memberId, payload) =>
  portalApi().post(`/${organizationId}/member/${memberId}/password`, payload);
export const updateMemberPersonalInfoByOrganization = (organizationId, memberId, payload) =>
  portalApi().patch(`/${organizationId}/member/${memberId}/personal-info`, payload);
export const deleteMemberByOrganization = (organizationId, memberId) =>
  portalApi().delete(`/${organizationId}/member/${memberId}`);

export const uploadPersonalInformation = (formData) =>
  portalApi().patch('me', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const signupMember = (payload) => portalApi().post('/member/signup', payload);
export const createMember = (payload) => portalApi().post('member', payload);

export const getUsers = (searchParms) => portalApi().get(`/users?${searchParms}`);

export const adminSignupMember = (payload) => portalApi().post('/admin/member/signup', payload);
export const adminSearchUser = (orgId) => portalApi().get(`/${orgId}/users`);
export const admincreateMember = (orgId, payload) => portalApi().post(`${orgId}/member`, payload);
export const adminBulkUpload = (orgId, formData) => portalApi().post(`${orgId}/bulk-upload`, formData);

export const fetchMembers = (searchParams) => portalApi().get(`/member?${searchParams}`);
export const fetchMember = (memberId) => portalApi().get(`/member/${memberId}`);
export const updateMember = (memberId, payload) => portalApi().patch(`/member/${memberId}`, payload);
export const updateMemberPassword = (memberId, payload) => portalApi().post(`/member/${memberId}/password`, payload);
export const updatePersonalInfoMember = (memberId, payload) =>
  portalApi().patch(`/member/${memberId}/personal-info`, payload);
export const deleteMember = (memberId) => portalApi().delete(`/member/${memberId}`);

export const fetchUnits = (searchParams) => portalApi().get(`unit?${searchParams}`);
export const fetchUnit = (id) => portalApi().get(`unit/${id}`);
export const createUnit = (payload) => portalApi().post('/unit', payload);
export const updateUnit = (unitId, payload) => portalApi().patch(`/unit/${unitId}`, payload);
export const deleteUnit = (id) => portalApi().delete(`/unit/${id}`);

export const fetchNotifications = (page = 1) => portalApi().get(`/me/notifications?page=${page}`);
export const readNotification = (id = null) => {
  if (id) {
    return portalApi().patch(`me/notifications/${id}/read`);
  }

  return portalApi().patch('me/notifications/read');
};

export const fetchApplications = () => portalApi().get('/my-apps');

export const fetchPasswordPolicy = (payload) => portalApi().post('/password-policy', payload);
export const confirmPassword = (payload) => portalApi().post('/confirm-password', payload);

export const bulkUpload = (formData) => portalApi().post('/bulk-upload', formData);

export const updateProfile = (payload) => portalApi().patch('/me', payload);

export const requestRemoval = () => portalApi().post('/remove-request');
export const updateCorporateAccount = (payload) => portalApi().patch('/me/member', payload);

export const fetchAdminMobileDevices = (searchParams, payload) =>
  portalApi().post(`/admin-mobile-devices/devices?${searchParams}`, payload);
export const updateAdminMobileDevice = (payload) => portalApi().patch('/admin-mobile-devices/devices', payload);
export const fetchMobileDevices = (searchParams, payload) =>
  portalApi().post(`/organization-mobile-devices/devices?${searchParams}`, payload);
export const updateMobileDevice = (payload) => portalApi().patch('/organization-mobile-devices/devices', payload);
export const deleteMobileDevice = (orgDeviceId) =>
  portalApi().delete('/organization-mobile-devices/devices', { data: { org_device_id: orgDeviceId } });

export const issueDeviceQrCode = (payload) => portalApi().post('/organization-mobile-devices/qr-code', payload);
export const refreshDeviceQrCode = (qrCode) =>
  portalApi().patch('/organization-mobile-devices/qr-code', { qr_code: qrCode });

export const issueAdminDeviceQrCode = (organizationId, qrCodeData) => {
  const payload = {
    organization_id: organizationId,
    ...qrCodeData,
  };

  return portalApi().post('/admin-mobile-devices/qr-code', payload);
};

export const refreshAdminDeviceQrCode = (organizationId, qrCode) => {
  const payload = {
    organization_id: organizationId,
    qr_code: qrCode,
  };

  return portalApi().patch('/admin-mobile-devices/qr-code', payload);
};

export const fetchMembersEligibleToPinPolicy = (pinPolicy, orgDeviceId = undefined) => {
  const payload = { pin_policy: pinPolicy };

  if (orgDeviceId) {
    payload.org_device_id = orgDeviceId;
  }

  return portalApi().post('/organization-mobile-devices/eligible-members', payload);
};

export const fetchAdminMembersEligibleToPinPolicy = (organizationId, pinPolicy, orgDeviceId = undefined) => {
  const payload = {
    organization_id: organizationId,
    pin_policy: pinPolicy,
  };

  if (orgDeviceId) {
    payload.org_device_id = orgDeviceId;
  }

  return portalApi().post('/admin-mobile-devices/eligible-members', payload);
};

export const redefineMemberPin = (payload) => portalApi().patch('organization-mobile-devices/member-pin', payload);
export const fetchActiveMembers = (orgDeviceId) =>
  portalApi().post('organization-mobile-devices/active-members', { org_device_id: orgDeviceId });

export const fetchOrganizations = (searchParams) => portalApi().get(`/organization?${searchParams}`);
export const updateOrganization = (id, formData) => portalApi().patch(`/organization/${id}`, formData);
export const deleteOrganization = (id) => portalApi().delete(`/organization/${id}`);

export const fetchAllOrganizations = (searchParams) => portalApi().get(`/list-organization?${searchParams}`);

export const fetchBuUsers = (searchParams) => portalApi().get(`bu-user?${searchParams}`);
export const fetchBuUser = (id) => portalApi().get(`/bu-user/${id}`);
export const createBuUser = (payload) => portalApi().post('/bu-user', payload);
export const updateBuUser = (id, payload) => portalApi().patch(`/bu-user/${id}`, payload);
export const deleteBuUser = (id) => portalApi().delete(`/bu-user/${id}`);

export const fetchMemberHistory = (searchParams) => portalApi().get(`/org-members-history?${searchParams}`);
export const fetchLogs = (searchParams) => portalApi().get(`/get-logs?${searchParams}`);
export const fetchBuLogs = (searchParams) => portalApi().get(`braincare/get-logs?${searchParams}`);

export const eduLogin = (payload) => portalApi().post('/edu/login', payload);
export const acceptEduTerms = () => portalApi().patch('/edu/accept-terms/accept');
export const resetEduPassword = (payload) => portalApi().post('/edu/reset-password', payload);

export const updateMemberOrganization = (payload) => portalApi().patch('/me/member-organization', payload);

export const getDoctorNames = (doctors) => portalApi().post('doctor-names', { doctors });
export const searchUser = (searchParams) => portalApi().get(`search-user?${searchParams}`);

export const getUsersById = (searchParams) => portalApi().get(`users-by-id?${searchParams}`);
export const getOrganizationsById = (searchParams) => portalApi().get(`organizations-by-id?${searchParams}`);
